import type { ExportSummaryDataset } from '../models/export.types'

/** BigQuery returns an object; the legacy template interpolated it as `[object Object]`. */
export function resolveDatasetName(
  dataset: ExportSummaryDataset | string | null | undefined,
): string {
  if (typeof dataset === 'string') return dataset
  return dataset?.name ?? dataset?.datasetId ?? dataset?.id ?? ''
}
